<template>
  <v-card v-if="items.length" class="placeholder-suggestion-list" elevation="4" max-width="320">
    <v-list dense class="py-0">
      <v-list-item
        v-for="(item, index) in items"
        :key="item.token"
        :data-token="item.token"
        :class="{ 'v-list-item--active primary--text': index === selectedIndex }"
        @click="selectItem(index)"
        @mouseenter="selectedIndex = index"
      >
        <v-list-item-content>
          <v-list-item-title class="text-body-2">{{ item.value }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{ item.label }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PlaceholderSuggestionItem } from "./placeholder-suggestion-items";

@Component({})
export default class PlaceholderSuggestionList extends Vue {
  @Prop({ default: () => [] })
  items!: PlaceholderSuggestionItem[];

  @Prop({ required: true })
  command!: (item: PlaceholderSuggestionItem) => void;

  selectedIndex = 0;

  @Watch("items")
  onItemsChange() {
    this.selectedIndex = 0;
  }

  selectItem(index: number) {
    const item = this.items[index];
    if (item) {
      this.command(item);
    }
  }

  onKeyDown(event: KeyboardEvent): boolean {
    if (!this.items.length) return false;

    if (event.key === "ArrowUp") {
      this.selectedIndex = (this.selectedIndex + this.items.length - 1) % this.items.length;
      return true;
    }

    if (event.key === "ArrowDown") {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
      return true;
    }

    if (event.key === "Enter" || event.key === "Tab") {
      this.selectItem(this.selectedIndex);
      return true;
    }

    return false;
  }
}
</script>

<style scoped>
.placeholder-suggestion-list {
  overflow: auto;
  max-height: 240px;
  font-family: "Roboto", sans-serif;
}
</style>
